import * as React from "react"
import Svg, { Path } from "react-native-svg"

function EyeOffIcon({ color = "#6A7085", ...props }) {
  return (
    <Svg
      width={24}
      height={24}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <Path
        d="M3 3l18 18M10.6 10.6a2.5 2.5 0 003.5 3.5M6.5 6.9C4.3 8.3 2.7 10.3 1.5 12c1.9 3.3 5.4 7 10.5 7 1.7 0 3.2-.4 4.6-1.1M9.9 4.2A10.6 10.6 0 0112 4c5.1 0 8.6 3.7 10.5 7-.6 1.1-1.4 2.2-2.3 3.2"
        stroke={color}
        strokeWidth={1.8}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </Svg>
  )
}

export default EyeOffIcon
